// 分润设置
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex" :initTableList="initTableList"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid :stripe="true" ref="table-m1" v-bind="gridData" show-overflow height="100%" border="default"
                    :row-config="{ isHover: true }"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="slBenefitSetAdd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"
                    plain>重置</vxe-button> -->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="认证等级:" field="orderTypeName">
                  <template v-slot>
                    <el-select v-model="formData.authLevel" style="width: 165px;" :clearable="true">
                      <el-option label="待认证" :value="1"/>
                      <el-option label="初级" :value="3"/>
                      <el-option label="中级" :value="5"/>
                      <el-option label="高级" :value="7"/>
                      <el-option label="资深级" :value="9"/>
                    </el-select>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager class="pager_left">
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {indexPageMixins} from "@/mixins/tabChang";
import { mapGetters } from 'vuex';

export default {
  name: 'share',

  components: {editView, pager},
  mixins: [indexPageMixins],
  data() {
    return {
      total: 0,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        authLevel: null
      },
      formData: {
        authLevel: null
      },
      pageSizes: [20, 50, 100],
      gridData: {},
      showEdit: false,
      activeName: 'second',
      dataId: 0,

      column: [
        {type: 'seq', title: '序号', width: 60, resizable: false, fixed: 'left'},
        {
          title: '认证等级', field: 'authLevel', width: 150, slots: {
            default: ({row}) => {
              if (row.authLevel == 1) {
                return [
                  <div class="txt-status disable">
                    <span>待认证</span>
                  </div>
                ];
              } else if (row.authLevel == 3) {
                return [
                  <div class="txt-status">
                    <span>初级</span>
                  </div>
                ];
              } else if (row.authLevel == 5) {
                return [
                  <div class="txt-status">
                    <span>中级</span>
                  </div>
                ];
              } else if (row.authLevel == 7) {
                return [
                  <div class="txt-status">
                    <span>高级</span>
                  </div>
                ];
              } else if (row.authLevel == 9) {
                return [
                  <div class="txt-status">
                    <span>资深级</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '分润比列', field: 'benefitRate', width: 150,},
        {field: 'createTime', title: '创建时间', width: 150},
        {title: '创建人', field: 'createBy', width: 150,},
        {
          width: 60, fixed: 'right', title: '操作', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ],
    };
  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }

  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.slBenefitSetAdd = this.permissions["slBenefitSetAdd"];
    this.slBenefitSetView = this.permissions["slBenefitSetView"];
    this.slBenefitSetEdit = this.permissions["slBenefitSetEdit"];
  },
  methods: {
		toFilterData() {
            this.searchEvent();
     },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.slBenefitSet.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.column
      };
      this.gridData = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    handleClick(tab, event) {
      console.log(tab, event, 'handleClick');
      this.flushed()
    },

    updateChange() {
      this.flushed()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchValue = ''
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.orderTypeName = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
  }
};
</script>


<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.pager_left {
  margin-left: 1px;
}
</style>
